app.service("ProductCabinetKitchenService",
    ['$rootScope', 'ProductService',
        function ($rootScope, ProductService) {

            const siteHelper = $rootScope.site_helper;
            const modelConstructor = $rootScope.model_constructor;

            const ProductCabinetKitchenModel = modelConstructor.extend(ProductService.BasicProductModel, {
                id: "product_cabinet_kitchen",
                base_component_id: "cabinet_kitchen",
                dataResponseHandler: dataResponseHandler,
                applyItemHandler: applyItemHandler,
                clicbox_colour_ids: []
            });

            this.factory = new ProductService.BasicProductModelFactory({
                validVariationPointers: function (variationIDs) {
                    return [];
                },
                birth: function (values) {
                    return new ProductCabinetKitchenModel(values);
                },
                applyModelVariation: applyModelVariation
            });


            function applyModelVariation(model) {

                this.super(model);


                const clicboxColourModel = $rootScope.factory.clicbox_colour.getModel(this.root.variation_ids);

                const clicboxColourIDs = [];
                for (let clicboxColourID in clicboxColourModel.choices) {
                    clicboxColourIDs.push(clicboxColourID);
                }
                model.clicbox_colour_ids = clicboxColourIDs;
            }

            function dataResponseHandler(data) {
                const units = [];
                if (data.units) {
                    for (let key in data.units) {
                        units.push(data.units[key])
                    }
                }
                return units
            }

            function applyItemHandler(product) {

                this.super(product);

                const model = this.root;

                product.quantity = 1;
                product.group_name = "Kitchen Cabinet";
                if (product.tags.indexOf('pack_to_order') !== -1) {
                    if (model.assembly_id !== "rigid") {

                        product.lead_time_corner_strip = "days-10";
                    }
                }

                for (let i = 0; i < model.clicbox_colour_ids.length; i++) {
                    const clicboxColourID = model.clicbox_colour_ids[i];
                    const colourProduct = product[clicboxColourID];
                    if (colourProduct) {
                        colourProduct.range = model.request_range_id;
                        colourProduct.request_range_id = model.request_range_id;
                        colourProduct.request_api_code = model.api_code;
                        colourProduct.api_code = colourProduct.product_code ? colourProduct.product_code : model.api_code;
                    }
                }
                if(product.id === "720_base_curved_300"){
                    console.log(product)
                    product.description = "720H x 300W (comes as 2 units) Only suitable for Wilton and Lacarre Curved Doors (715x298x298 curved door plus 715x256 standard door order separately). Not ClicBox - screw together. * Includes tool-less adjustable legs * Hinge plate positions are centred 100mm top and bottom * Hinge plate positions are pre-drilled for euro screws * Hinge hole door drillings are 98mm top and bottom. Please see Bella Curved Door section for Bella Version"
                }

                siteHelper.applyValues(product, {

                    collectImageParams: function () {
                        const params = this.super();

                        //The images are teh same for every colour so there is no sense reloading every time with a different product code
                        const clicboxColour = "white";

                        params.image_type_id = "product";
                        params.site_range_id = "bella";
                        params.api_code = "stock";
                        params.product_code = product[clicboxColour] ? product[clicboxColour].api_code : null;
                        params.width = 250;
                        params.height = 250;

                        return params;
                    },

                    formatPrice: function (priceParams, emptyIfZero) {
                        priceParams = priceParams ? priceParams : {};
                        priceParams.clicbox_colour = priceParams.clicbox_colour ? priceParams.clicbox_colour : $rootScope.navigation_model.state_ids.clicbox_colour_id;
                        return this.super(priceParams, emptyIfZero);
                    },
                    finalPrice: function (optionTermIDs) {
                        return finalPrice(product, optionTermIDs);
                    }
                });
            }

            function finalPrice(product, optionTermIDs) {

                const clicboxColour = optionTermIDs.clicbox_colour;

                const colourProduct = clicboxColour ? product[clicboxColour] : null;

                if (!colourProduct) {
                    return 0;
                }

                return $rootScope.service.product.appliedMinimumDiscountPrice(colourProduct, colourProduct.price);
            }

        }])